__turbopack_context__.v({
  "brand": "KoiirW_brand",
  "default": "KoiirW_default",
  "error": "KoiirW_error",
  "noBorder": "KoiirW_noBorder",
  "root": "KoiirW_root",
  "success": "KoiirW_success",
  "warning": "KoiirW_warning",
});
